export default class Cursors {
	constructor(elm) {
        this.wrapper = elm;
		this.cursors = this.wrapper.querySelectorAll('[data-cursor]');

        this.breakpoint = window.matchMedia('pointer: coarse');
        this.breakpoint.addEventListener('change', () => {
            this.init();
        });
        this.init();
	}

	init() {
        if (this.breakpoint.matches === true) {
			this.destroy();
            return;
        }

		this.active = true;

		this.boundMouseMoveListener = this.mouseMoveListener.bind(this);
		document.addEventListener('pointermove', this.boundMouseMoveListener);

		this.boundMouseOverListener = this.mouseOverListener.bind(this);
		document.addEventListener('mouseover', this.boundMouseOverListener);

		this.boundMouseOutListener = this.mouseOutListener.bind(this);
		document.addEventListener('mouseout', this.boundMouseOutListener);

		requestAnimationFrame(timestamp => this.render(timestamp));

		this.boundBlessListener = this.blessListener.bind(this);
		document.addEventListener('bless', this.boundBlessListener);
	}

    mouseMoveListener(e) {
		this.clientX = e.clientX;
		this.clientY = e.clientY;
	}

	mouseOverListener(e) {
		this.cursors.forEach(cursor => {
			let cursorID = cursor.getAttribute('data-cursor');
			if (e.target.closest('[data-show-cursor="'+cursorID+'"]')) {
				cursor.classList.add('c-cursor--visible');
			}
		});
	}

	mouseOutListener(e) {
		this.cursors.forEach(cursor => {
			let cursorID = cursor.getAttribute('data-cursor');
			if (e.target.closest('[data-show-cursor="'+cursorID+'"]')) {
				cursor.classList.remove('c-cursor--visible');
			}
		});
	}

	render(timestamp) {
		if (!this.active) {
			return;
		}
		this.wrapper.style.transform = `translate(${this.clientX}px, ${this.clientY}px)`;
		requestAnimationFrame(timestamp => this.render(timestamp));
	}

	blessListener() {
		this.cursors.forEach(cursor => {
			cursor.classList.remove('c-cursor--visible');
		});
	}

	destroy() {
		this.cursors.forEach(cursor => {
			cursor.classList.remove('c-cursor--visible');
		});
		this.active = false;
		document.removeEventListener('mousemove', this.boundMouseMoveListener);
		document.removeEventListener('mouseover', this.boundMouseOverListener);
		document.removeEventListener('mouseout', this.boundMouseOutListener);
	}
}
